import { Choice } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { ChoicesContext, ChoicesContextProps } from '@/contexts/choices'
import { useGeneralErrors } from '@/hooks/useGeneralErrors'

interface UseChoicesProps {
  choices: ChoicesContextProps['choices']
  addChoice: (choice: Choice) => void
  removeChoiceByModuleAndStep: (moduleId: string, stepId: string) => void
}

export const useChoices = (): UseChoicesProps => {
  const { choices, setChoices } = useContext(ChoicesContext)
  const { clearGeneralErrors } = useGeneralErrors()

  const addChoice = (choice: Choice) => {
    if (!choices) return
    clearGeneralErrors()

    const index = choices.findIndex((c) => c.stepId === choice.stepId && c.moduleId === choice.moduleId)

    // If already exists a choice with the same step, replace it
    if (index !== -1) {
      const newChoices = [...choices]
      newChoices[index] = choice

      return setChoices(newChoices)
    }

    setChoices([...choices, choice])
  }

  const removeChoiceByModuleAndStep = (moduleId: string, stepId: string) => {
    if (!choices) return

    setChoices((prev) => prev.filter((choice) => !(choice.moduleId === moduleId && choice.stepId === stepId)))
  }

  return { choices, addChoice, removeChoiceByModuleAndStep }
}
